export const temporaryTranslations = {
  "ACTN0128": "Share link copied to clipboard!",
  "ACTN0129": "Share eSIM is not supported for this eSIM.",
  "ACTN0130": "Failed to initialize KYC verification",
  "ACTN0131": "Failed to refresh KYC status",
  "ACTN0132": "Done",
  "ACTN0133": "Before you start KYC",
  "ACTN0134": "Please keep the following ready for a smooth verification process:",
  "ACTN0135": "Please carry the government issued identity card., Use good lighting while taking a picture of the ID card., Use a plain background while checking liveness or taking the picture.",
  "ACTN0136": "KYC Status Updated",
  "ACTN0137": "Current status:",
  "ACTN0138": "Your verification has been reviewed. If needed, please contact support for the next steps.",
  "ACTN0139": "Complete KYC Verification",
  "ACTN0140": "KYC Details",
  "ACTN0141": "KYC Verification",
  "ACTN0142": "Initializing KYC...",
  "ACTN0143": "KYC Completed",
  "ACTN0144": "KYC Pending",
  "ACTN0145": "Your identity verification is successfully completed.",
  "ACTN0146": "Your identity verification is currently under review. We will notify you once the review process is complete.",
  "ACTN0147": "Could not get KYC session URL",
  "ACTN0148": "Please scan the QR code using your mobile device to complete your identity verification.",
  "ACTN0149": "Refresh KYC Status",
  "ACTN0150": "Certain bundles require KYC verification",
  "ACTN0121": "Purchased On",
}